import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/lib/i18n';

/** 110 §8 — real copy, shipped. */
export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="max-w-[78ch] p-6">
      <h1 className="mb-1 text-lg font-semibold">{t('notebook.notFound.title')}</h1>
      <p className="mb-3 text-[var(--muted-foreground)]">{t('notebook.notFound.body')}</p>
      <Button variant="outline" size="sm" asChild>
        <Link to="/">{t('notebook.notFound.back')}</Link>
      </Button>
    </div>
  );
}
